export default {
  GET_INVENTORIES: (state) => state.inventories,
  GET_INVENTORY: (state) => state.inventory,
};
